var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-table-view" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.projectList,
            border: "",
            "empty-text": "暂无数据",
            "highlight-current-row": "",
          },
          on: { "row-click": _vm.handleRowClick },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "300",
              label: "标题",
              prop: "name",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticClass: "pl10 one-text-overflow" }, [
                      _vm._v(
                        " " + _vm._s(_vm.removeHtmlTag(scope.row.name)) + " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", width: "100", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.type == "3"
                      ? _c("span")
                      : _vm._l(_vm.projectStatusList, function (status) {
                          return _c("span", { key: status.code }, [
                            status.code == scope.row.status
                              ? _c("span", [
                                  _vm._v(" " + _vm._s(status.name) + " "),
                                ])
                              : _vm._e(),
                          ])
                        }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "类型", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.type == "3"
                      ? _c("span", [_vm._v("文件夹")])
                      : _c("span", [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getType(scope.row.type).name) +
                                " "
                            ),
                          ]),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "创建人", prop: "userName" },
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "创建时间", prop: "createTime" },
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "更新时间", prop: "updateTime" },
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        _vm.canEditProject(scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: ["editor"],
                                    expression: "['editor']",
                                  },
                                ],
                                attrs: { type: "text", icon: "el-icon-edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toProjectHandle(
                                      scope.row,
                                      "editor"
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 编辑 ")]
                            )
                          : _vm._e(),
                        _c("span"),
                        _vm.canEditProject(scope.row) && scope.row.status == 2
                          ? _c(
                              "el-popconfirm",
                              {
                                attrs: { title: "确定停止收集该项目吗？" },
                                on: {
                                  confirm: function ($event) {
                                    return _vm.stopProject(scope.row.formKey)
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: ["myProject_stop"],
                                        expression: "['myProject_stop']",
                                      },
                                    ],
                                    staticClass: "text-danger ml-10",
                                    attrs: {
                                      slot: "reference",
                                      type: "text",
                                      icon: "el-icon-video-pause",
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v(" 停止 ")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.canEditProject(scope.row) && scope.row.status != 2
                          ? _c(
                              "el-popconfirm",
                              {
                                attrs: { title: "确定删除该项目吗？" },
                                on: {
                                  confirm: function ($event) {
                                    return _vm.logicDeleteForm(
                                      scope.row.formKey
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: ["myProject_delete"],
                                        expression: "['myProject_delete']",
                                      },
                                    ],
                                    staticClass: "text-danger ml-10",
                                    attrs: {
                                      slot: "reference",
                                      type: "text",
                                      icon: "el-icon-delete",
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v(" 删除 ")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["myProject_statistics"],
                                expression: "['myProject_statistics']",
                              },
                            ],
                            staticClass: "ml-10",
                            attrs: {
                              type: "text",
                              icon: "el-icon-data-analysis",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toProjectHandle(
                                  scope.row,
                                  "statistics"
                                )
                              },
                            },
                          },
                          [_vm._v("统计")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-view" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit(
                                  "openPreviewHandle",
                                  scope.row.formKey
                                )
                              },
                            },
                          },
                          [_vm._v(" 预览 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              icon: "el-icon-document-copy",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit(
                                  "copyProject",
                                  scope.row.formKey
                                )
                              },
                            },
                          },
                          [_vm._v(" 复制 ")]
                        ),
                        _vm.canShowProjectPermission(scope.row)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", icon: "el-icon-s-flag" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit(
                                      "addProjectAssistant",
                                      scope.row.formKey
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 项目权限 ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }